import { useEffect, useState } from "react";
import { SelectOptionType } from "react-select";
import { OrderStatusLabelMap, OrderStatusList } from "../../../../models/Order";

export default function useFilterStatus(props: { filterStatus?: string }) {
	const statusOptions: SelectOptionType[] = [
		// {
		//     label: "Tất cả",
		//     value: ``,
		//     object: "",
		// },
	];

	//setup statusOpts
	OrderStatusList.forEach((id) => {
		statusOptions.push({
			label: OrderStatusLabelMap.get(id) || "",
			value: id.toString(),
			object: "",
		});
	});
	const setupInitialStatus = (selectOpts: SelectOptionType[], compareVal: string | undefined) => {
		const listCompare = compareVal?.split(";");
		const initialStatus: string[] = [];
		listCompare?.forEach((item) => {
			const acceptInitial = selectOpts.find((opt) => opt.value === item || "");
			if (acceptInitial) initialStatus.push(acceptInitial.value);
		});
		return initialStatus || [selectOpts[0].value];
	};

	const [status, setStatus] = useState<string[]>(() => setupInitialStatus(statusOptions, props.filterStatus || ""));

	useEffect(() => {
		setStatus(setupInitialStatus(statusOptions, props.filterStatus || ""));
	}, [props.filterStatus]);

	return {
		status,
		setStatus,
		statusOptions,
	};
}
